<template>
  <div class="form-group">
    <label class="control-label">{{ label }}</label>
    <div class="input-group">
      <b-form-input :value="value"
                    :placeholder="placeholder"
                    :type="type"
                    :autocomplete="autocomplete"
                    @input="handleInput"
      />
    </div>
    <b-form-text v-if="description">{{description}}</b-form-text>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: false,
      default: '',
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    value: {
      type: String,
      required: false,
      default: '',
    },
    type: {
      type: String,
      required: false,
      default: 'text',
    },
    autocomplete: {
      type: String,
      required: false,
      default: '',
    },
    description: {
      type: String,
      required: false,
      default: '',
    },
  },
  methods: {
    handleInput(val) {
      this.$emit('input', val);
    },
  },
}
</script>
